// Copyright Abridged, Inc. 2021,2024. All Rights Reserved.
// Node module: @collabland/sdk
// This file is licensed under the MIT License.
// License text available at https://opensource.org/license/mit/

import {model, property} from '@loopback/repository';

/**
 * The model class is generated from OpenAPI schema - NewTokenPermissionedChat
 * (tsType: Omit<TokenPermissionedChat, 'id' | 'pk' | 'sk' | 'classifier'>,
schemaOptions: { title: 'NewTokenPermissionedChat', exclude: [ 'id', 'pk',
'sk', 'classifier' ] })
 */
@model({name: 'NewTokenPermissionedChat'})
export class NewTokenPermissionedChat {
  constructor(data?: Partial<NewTokenPermissionedChat>) {
    if (data != null && typeof data === 'object') {
      Object.assign(this, data);
    }
  }

  /**
   *
   */
  @property({
    jsonSchema: {
      type: 'string',
    },
  })
  createdTime?: string;

  /**
   *
   */
  @property({
    jsonSchema: {
      type: 'string',
    },
  })
  classifierGroup?: string;

  /**
   *
   */
  @property({
    jsonSchema: {
      type: 'string',
    },
  })
  name?: string;

  /**
   *
   */
  @property({
    jsonSchema: {
      type: 'string',
    },
  })
  description?: string;

  /**
   *
   */
  @property({
    jsonSchema: {
      type: 'string',
    },
  })
  roleId?: string;

  /**
   *
   */
  @property({
    jsonSchema: {
      type: 'string',
    },
  })
  groupId?: string;

  /**
   *
   */
  @property({
    jsonSchema: {
      type: 'string',
      format: 'BigDecimal',
    },
  })
  minToken?: string;

  /**
   *
   */
  @property({
    jsonSchema: {
      type: 'string',
      format: 'BigDecimal',
    },
  })
  maxToken?: string;

  /**
   *
   */
  @property({
    jsonSchema: {
      type: 'number',
    },
  })
  chainId?: number;

  /**
   *
   */
  @property({
    jsonSchema: {
      type: 'string',
    },
  })
  tokenSymbol?: string;

  /**
   *
   */
  @property({
    jsonSchema: {
      type: 'string',
    },
  })
  tokenId?: string;

  /**
   *
   */
  @property({
    jsonSchema: {
      type: 'string',
    },
  })
  collectionName?: string;

  /**
   *
   */
  @property({
    jsonSchema: {
      type: 'string',
    },
  })
  eventId?: string;

  /**
   *
   */
  @property({
    jsonSchema: {
      type: 'string',
    },
  })
  platform?: string;

  /**
   *
   */
  @property({
    jsonSchema: {
      type: 'string',
    },
  })
  contractAddress?: string;

  /**
   *
   */
  @property({
    jsonSchema: {
      type: 'string',
    },
  })
  type?: string;

  /**
   *
   */
  @property({
    jsonSchema: {
      type: 'string',
    },
  })
  scheme?: string;

  /**
   *
   */
  @property({
    jsonSchema: {
      type: 'string',
    },
  })
  query?: string;

  /**
   *
   */
  @property({
    jsonSchema: {
      type: 'object',
      additionalProperties: true,
    },
  })
  variables?: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    [additionalProperty: string]: any;
  };

  /**
   *
   */
  @property({
    jsonSchema: {
      type: 'string',
      format: 'CAIPAsset',
    },
  })
  asset?: string;

  /**
   *
   */
  @property({
    jsonSchema: {
      type: 'boolean',
    },
  })
  requiresMetadata?: boolean;

  /**
   *
   */
  @property({
    jsonSchema: {
      type: 'string',
    },
  })
  version?: string;
}

export interface NewTokenPermissionedChatRelations {
  // describe navigational properties here
}

export type NewTokenPermissionedChatWithRelations = NewTokenPermissionedChat &
  NewTokenPermissionedChatRelations;
